export default __webpack_public_path__ + "img/intro-icon.png?594c";